module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    attrs: {
      "id": "diretorias"
    }
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Diretorias")])], 1), _c('div', {
    staticClass: "conteudo",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('carousel', {
    staticClass: "diretorias",
    attrs: {
      "paginationEnabled": false,
      "navigationEnabled": true,
      "navigationClickTargetSize": 0,
      "navigationNextLabel": _vm.proximo,
      "navigationPrevLabel": _vm.anterior,
      "perPage": 1,
      "perPageCustom": _vm.breakpoints
    }
  }, [_c('slide', [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "--green-hover"
  }, [_c('i', {
    staticClass: "proad proad-cifrao",
    attrs: {
      "slot": "icone"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("DCF")]), _c('p', {
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("A Diretoria de Contabilidade e Finanças é o órgão central do sistema de administração financeira e contábil da universidade.")])], 2)], 1)]), _c('slide', [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "--wine-hover"
  }, [_c('i', {
    staticClass: "proad proad-livro",
    attrs: {
      "slot": "icone"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("DC")]), _c('p', {
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("A Diretoria de Contratos coordena, planeja e acompanha a execução fisico-financeira fiscalizando administrativamente todos os contratos.")])], 2)], 1)]), _c('slide', [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "--yellow-hover"
  }, [_c('i', {
    staticClass: "proad proad-chat",
    attrs: {
      "slot": "icone"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("DL")]), _c('p', {
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("A Diretoria de Logística tem a finalidade de planejar, coordenar e organizar o sistema de arquivos da UFRN em sua forma documental e eletrônica.")])], 2)], 1)]), _c('slide', [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'DCOMIndex'
      }
    }
  }, [_c('bloquinho', {
    staticClass: "--blue-hover"
  }, [_c('i', {
    staticClass: "proad proad-predio",
    attrs: {
      "slot": "icone"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("DCOM")]), _c('p', {
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("A Diretoria de Compras tem a finalidade de planejar, coordenar, controlar e executar as compras institucionais de âmbito nacional e internacional.")])], 2)], 1)], 1), _c('slide', [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "--orange-hover"
  }, [_c('i', {
    staticClass: "proad proad-escudo",
    attrs: {
      "slot": "icone"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("DSP")]), _c('p', {
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("A Diretoria de Segurança Patrimonial tem a finalidade de planejar, coordenar, executar e avaliar a segurança patrimonial.")])], 2)], 1)])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-542dfe65","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Diretorias.vue
// module id = 489
// module chunks = 0